import { ReactComponent as Booking } from '../../assets/booking.svg'
import { ReactComponent as Desking } from '../../assets/desking.svg'
import { ReactComponent as ManageIcon } from '../../assets/manage.svg'
import { ReactComponent as Statics } from '../../assets/statics.svg'
import { ReactComponent as SystemSetting } from '../../assets/systemSetting.svg'

import { ReactComponent as ActBooking } from '../../assets/active_icon/act_booking.svg'
import { ReactComponent as ActDesking } from '../../assets/active_icon/act_desking.svg'
import { ReactComponent as ActManageIcon } from '../../assets/active_icon/atc_manage.svg'
import { ReactComponent as ActStatics } from '../../assets/active_icon/act_statics.svg'
import { ReactComponent as ActSystemSetting } from '../../assets/active_icon/act_sys_setting.svg'

import { ReactComponent as ApproveIcon } from '../../assets/active_icon/approve.svg'
import { ReactComponent as ApproveBuleIcon } from '../../assets/active_icon/act_approve.svg'
import { ReactComponent as RelocationIcon } from '../../assets/active_icon/deskremove.svg'
import { ReactComponent as RelocationBuleIcon } from '../../assets/active_icon/act_deskremove.svg'

import { ReactComponent as DepartmentManageIcon } from '../../assets/active_icon/depart_manager.svg'
import { ReactComponent as ActDepartmentManageIcon } from '../../assets/active_icon/atc_depart_manager.svg'
import { ReactComponent as AlarmGrayIcon } from '../../assets/alarmGray.svg'
import { ReactComponent as AlarmBuleIcon } from '../../assets/active_icon/alarmBule.svg'
import { ReactComponent as UserManage } from '../../assets/userManage.svg'
import { ReactComponent as ActUserManage } from '../../assets/active_icon/atc_user_manage.svg'

import { ReactComponent as InventoryIcon } from '../../assets/active_icon/inventory.svg'
import { ReactComponent as InventoryBuleIcon } from '../../assets/active_icon/act_inventory.svg'

import { hashArrToObjByKey, getHashParentArr } from '../../helpers/text'

export const ALL_MENUS_TREE = [
  {
    name: '工位预订',
    path: '/book',
    icon: <Booking />,
    activeIcon: <ActBooking></ActBooking>,
    sn: 'DESKBOOKING',
    level: 1
  },
  {
    name: '工位分配',
    path: '/map',
    icon: <Desking />,
    activeIcon: <ActDesking></ActDesking>,
    sn: 'DESKASSIGNATION',
    level: 1
  },
  {
    name: '空间管理',
    path: '/spaceManageFather',
    icon: <ManageIcon />,
    activeIcon: <ActManageIcon></ActManageIcon>,
    sn: 'SPACEMANAGEMENT',
    level: 1,
    children: [
      {
        name: '地点管理',
        path: '/location',
        sn: 'LOCATION_MANAGEMENT',
        parentPath: '/spaceManageFather',
        level: 2
      },
      {
        name: '工位管理',
        path: '/deskmanage-root',
        sn: 'DESKMANAGE_ROOT',
        parentPath: '/spaceManageFather',
        level: 2,
        children: [
          {
            name: '工位列表',
            path: '/spaceManage/floor',
            sn: 'DESKMANAGE',
            parentPath: '/deskmanage-root',
            level: 3
          },
          {
            name: '工位报修',
            path: '/desk-repair',
            sn: 'DESK-REPAIR',
            parentPath: '/deskmanage-root',
            level: 3
          },
          {
            name: '工位标签库',
            path: '/customizetags',
            sn: 'DESKLABEL',
            parentPath: '/deskmanage-root',
            level: 3
          },
          {
            name: '工作组管理',
            path: '/working-group',
            sn: 'DESK_GROUP_MANAGER',
            parentPath: '/deskmanage-root',
            level: 3
          }
        ]
      },
      {
        name: '工位管理(原来的)',
        path: '/spaceManage',
        sn: 'DESKMANAGEFLOOR',
        parentPath: '/spaceManageFather',
        level: 2
      },
      {
        name: '空间类型',
        path: '/space-types',
        sn: 'SPACETYPE',
        parentPath: '/spaceManageFather',
        level: 2
      }
    ]
  },
  {
    name: '部门空间经理',
    path: '/departmentSpaceFather',
    icon: <DepartmentManageIcon />,
    activeIcon: <ActDepartmentManageIcon />,
    sn: 'DEPTSPACEMANAGER',
    level: 1,
    children: [
      {
        name: '接口人工位分配',
        path: '/interfaceMap',
        sn: 'INTERFACERDESKASSIGNATION',
        parentPath: '/departmentSpaceFather',
        level: 2
      },
      {
        name: '接口人空间管理',
        path: '/interfaceManage/floor',
        sn: 'INTERFACERSPACEMANAGEMENT',
        parentPath: '/departmentSpaceFather',
        level: 2
      },
      {
        name: '部门工位申请',
        path: '/department-apply',
        sn: 'DEPARTMENT_DESK_APPLY',
        parentPath: '/departmentSpaceFather',
        level: 2
      }
    ]
  },

  {
    name: '系统管理',
    path: '/systemsetting',
    icon: <SystemSetting />,
    activeIcon: <ActSystemSetting></ActSystemSetting>,
    sn: 'SETTINGS',
    level: 1,
    children: [
      {
        name: '企业信息',
        path: '/company-setting',
        sn: 'COMPANYINFORMATIONSETTING',
        parentPath: '/systemsetting',
        level: 2
      },
      {
        name: '用户管理',
        path: '/userManage',
        sn: 'USERS',
        parentPath: '/systemsetting',
        level: 2,
        children: [
          {
            name: '组织架构',
            path: '/organizationalStructure',
            sn: 'DEPARTMENTS',
            parentPath: '/userManage',
            level: 3
          },
          {
            name: '用户列表',
            path: '/user-page',
            sn: 'USERLIST',
            parentPath: '/userManage',
            level: 3
          },
          {
            name: '角色权限',
            path: '/rolePermissions',
            sn: 'ROLES',
            parentPath: '/userManage',
            level: 3
          }
        ]
      },
      {
        name: '设置',
        path: '/set',
        sn: 'SETTING',
        parentPath: '/systemsetting',
        level: 2,
        children: [
          {
            name: '全局设置',
            path: '/global-config',
            sn: 'GLOBALSETTINGS',
            parentPath: '/set',
            level: 3
          },
          {
            name: '工位规则',
            path: '/deskrule',
            sn: 'DESKRULE',
            parentPath: '/set',
            level: 3
          },
          {
            name: '系统邮箱',
            path: '/email-setting',
            sn: 'SYSTEMMAILBOX',
            parentPath: '/set',
            level: 3
          },
          {
            name: '第三方集成',
            path: '/third-part',
            sn: 'THIRDCONFIG',
            parentPath: '/set',
            level: 3
          },
          {
            name: '通知设置',
            path: '/notice-setting',
            sn: 'MESSAGE_NOTIFY_SETTING',
            parentPath: '/set',
            level: 3
          },
          {
            name: '关于我们',
            path: '/about-setting',
            sn: 'ABOUTUS',
            parentPath: '/set',
            level: 3
          }
        ]
      },
      {
        name: '安全管理',
        path: '/securityManage',
        sn: 'SECURITYMANAGE',
        parentPath: '/systemsetting',
        level: 2,
        children: [
          {
            name: '日志管理',
            path: '/log',
            parentPath: '/securityManage',
            sn: 'LOGMANAGE',
            level: 3
          },
          {
            name: '自定义密码',
            path: '/custom-password',
            parentPath: '/securityManage',
            sn: 'CUSTOMPASSWORD',
            level: 3
          }
        ]
      },
      {
        name: '许可证',
        path: '/license',
        sn: 'LICENSEINFO',
        parentPath: '/systemsetting',
        level: 2
      }
    ]
  },
  {
    name: '分析统计',
    path: '/static',
    icon: <Statics />,
    activeIcon: <ActStatics></ActStatics>,
    sn: 'STATISTICS',
    level: 1,
    children: [
      {
        name: '实时概览',
        path: '/book-overview',
        sn: 'NOWDATAOVERVIEM',
        parentPath: '/static',
        level: 2
      },
      {
        name: '数据概览',
        path: '/statistics',
        sn: 'DATAOVERVIEW',
        parentPath: '/static',
        level: 2
      },
      {
        name: '预订数据概览',
        path: '/book-statistics',
        sn: 'BOOKSTATISTICS',
        parentPath: '/static',
        level: 2
      },
      {
        name: '预定报表',
        path: '/bookingForm',
        sn: 'RESERVEREPORT',
        parentPath: '/static',
        level: 2
      },
      {
        name: '分配统计报表',
        path: '/iframe',
        sn: 'JINGTIANIFRAME',
        parentPath: '/static',
        level: 2
      },
      {
        name: '部门工位月报',
        path: '/desk-report',
        sn: 'DEPT_DESK_REPORT',
        parentPath: '/static',
        level: 2
      }
    ]
  },
  {
    name: '工位搬迁',
    path: '/relocation-parent',
    icon: <RelocationIcon />,
    activeIcon: <RelocationBuleIcon />,
    sn: 'RELOCATION_MANAGEMENT',
    level: 1,
    children: [
      {
        name: '搬迁计划',
        path: '/relocation-plan',
        sn: 'RELOCATION_PLAN',
        parentPath: '/relocation-parent',
        level: 2
      },
      {
        name: '新建搬迁',
        path: '/relocation-draft',
        sn: 'RELOCATION_DRAFT',
        parentPath: '/relocation-parent',
        level: 2
      }
    ]
  },
  {
    name: '审批管理',
    path: '/approve-parent',
    icon: <ApproveIcon />,
    activeIcon: <ApproveBuleIcon />,
    sn: 'APPROVE_MANAGEMENT',
    level: 1,
    children: [
      {
        name: '部门工位审批',
        path: '/department-approve',
        sn: 'APPROVE_MANAGEMENT_DEPARTMENT',
        parentPath: '/approve-parent',
        level: 2
      },
      {
        name: '个人额度审批',
        path: '/user-approve',
        sn: 'USERAPPROVE',
        parentPath: '/approve-parent',
        level: 2
      }
    ]
  },
  {
    name: '报警管理',
    path: '/thresholdAlarm',
    icon: <AlarmGrayIcon />,
    activeIcon: <AlarmBuleIcon></AlarmBuleIcon>,
    sn: 'THRESHOLDALARM',
    level: 1,
    children: [
      {
        name: '报警设置',
        path: '/alarm-setting',
        sn: 'THRESHOLDALARM_SETTING',
        parentPath: '/thresholdAlarm',
        level: 2
      },
      {
        name: '报警通知列表',
        path: '/alarm-notify',
        sn: 'THRESHOLDALARM_NOTIFY',
        parentPath: '/thresholdAlarm',
        level: 2
      }
    ]
  },
  {
    name: '入职管理',
    path: '/pre-employee',
    icon: <UserManage />,
    activeIcon: <ActUserManage></ActUserManage>,
    sn: 'EMPLOYMENT',
    level: 1
  },
  {
    name: '工位盘点',
    path: '/desk-inventory',
    icon: <InventoryIcon />,
    activeIcon: <InventoryBuleIcon></InventoryBuleIcon>,
    sn: 'DESK_INVENTORY',
    level: 1,
    children: [
      {
        name: '全部任务',
        path: '/inventory',
        sn: 'ALL_INVENTORY_TASK',
        parentPath: '/desk-inventory',
        level: 2
      },
      {
        name: '我的任务',
        path: '/my-inventory',
        sn: 'MY_INVENTORY_TASK',
        parentPath: '/desk-inventory',
        level: 2
      }
    ]
  }
]

export const getHashPathArr = () => {
  const obj = hashArrToObjByKey(ALL_MENUS_TREE, 'path', 'children')
  // console.log(obj, '====SidebarMenus --obj')
  // console.log(getHashParentArr(obj, 'parentPath'), '===Parent')
  return getHashParentArr(obj, 'parentPath')
}
